function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Editor as Editor$1, NodeView } from '@tiptap/core';
export * from '@tiptap/core';
import Vue from 'vue';
import { BubbleMenuPlugin, BubbleMenuPluginKey } from '@tiptap/extension-bubble-menu';
import { FloatingMenuPlugin, FloatingMenuPluginKey } from '@tiptap/extension-floating-menu';
var BubbleMenu = Vue.extend({
  name: 'BubbleMenu',
  props: {
    editor: {
      type: Object,
      required: true
    },
    tippyOptions: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  watch: {
    editor: {
      immediate: true,
      handler: function handler(editor) {
        var _this = this;

        if (!editor) {
          return;
        }

        this.$nextTick(function () {
          editor.registerPlugin(BubbleMenuPlugin({
            editor: editor,
            element: _this.$el,
            tippyOptions: _this.tippyOptions
          }));
        });
      }
    }
  },
  render: function render(createElement) {
    return createElement('div', {
      style: {
        visibility: 'hidden'
      }
    }, this.$slots["default"]);
  },
  beforeDestroy: function beforeDestroy() {
    this.editor.unregisterPlugin(BubbleMenuPluginKey);
  }
});

var Editor = /*#__PURE__*/function (_Editor$) {
  _inherits(Editor, _Editor$);

  var _super = _createSuper(Editor);

  function Editor() {
    var _this2;

    _classCallCheck(this, Editor);

    _this2 = _super.apply(this, arguments);
    _this2.contentComponent = null;
    return _this2;
  }

  return Editor;
}(Editor$1);

var EditorContent = Vue.extend({
  name: 'EditorContent',
  props: {
    editor: {
      "default": null,
      type: Object
    }
  },
  watch: {
    editor: {
      immediate: true,
      handler: function handler(editor) {
        var _this3 = this;

        if (editor && editor.options.element) {
          this.$nextTick(function () {
            var element = _this3.$el;

            if (!element || !editor.options.element.firstChild) {
              return;
            }

            element.appendChild(editor.options.element.firstChild);
            editor.contentComponent = _this3;
            editor.setOptions({
              element: element
            });
            editor.createNodeViews();
          });
        }
      }
    }
  },
  render: function render(createElement) {
    return createElement('div');
  },
  beforeDestroy: function beforeDestroy() {
    var editor = this.editor;

    if (!editor.isDestroyed) {
      editor.view.setProps({
        nodeViews: {}
      });
    }

    editor.contentComponent = null;

    if (!editor.options.element.firstChild) {
      return;
    }

    var newElement = document.createElement('div');
    newElement.appendChild(editor.options.element.firstChild);
    editor.setOptions({
      element: newElement
    });
  }
});
var FloatingMenu = Vue.extend({
  name: 'FloatingMenu',
  props: {
    editor: {
      type: Object,
      required: true
    },
    tippyOptions: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  watch: {
    editor: {
      immediate: true,
      handler: function handler(editor) {
        var _this4 = this;

        if (!editor) {
          return;
        }

        this.$nextTick(function () {
          editor.registerPlugin(FloatingMenuPlugin({
            editor: editor,
            element: _this4.$el,
            tippyOptions: _this4.tippyOptions
          }));
        });
      }
    }
  },
  render: function render(createElement) {
    return createElement('div', {
      style: {
        visibility: 'hidden'
      }
    }, this.$slots["default"]);
  },
  beforeDestroy: function beforeDestroy() {
    this.editor.unregisterPlugin(FloatingMenuPluginKey);
  }
});

var VueRenderer = /*#__PURE__*/function () {
  function VueRenderer(component, props) {
    _classCallCheck(this, VueRenderer);

    var Component = Vue.extend(component);
    this.ref = new Component(props).$mount();
  }

  _createClass(VueRenderer, [{
    key: "element",
    get: function get() {
      return this.ref.$el;
    }
  }, {
    key: "updateProps",
    value: function updateProps() {
      var _this5 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.ref.$props) {
        return;
      } // prevents `Avoid mutating a prop directly` error message


      var originalSilent = Vue.config.silent;
      Vue.config.silent = true;
      Object.entries(props).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        _this5.ref.$props[key] = value;
      });
      Vue.config.silent = originalSilent;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.ref.$destroy();
    }
  }]);

  return VueRenderer;
}();

var nodeViewProps = {
  editor: {
    type: Object,
    required: true
  },
  node: {
    type: Object,
    required: true
  },
  decorations: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    required: true
  },
  extension: {
    type: Object,
    required: true
  },
  getPos: {
    type: Function,
    required: true
  },
  updateAttributes: {
    type: Function,
    required: true
  }
};

var VueNodeView = /*#__PURE__*/function (_NodeView) {
  _inherits(VueNodeView, _NodeView);

  var _super2 = _createSuper(VueNodeView);

  function VueNodeView() {
    _classCallCheck(this, VueNodeView);

    return _super2.apply(this, arguments);
  }

  _createClass(VueNodeView, [{
    key: "mount",
    value: function mount() {
      var _this6 = this;

      var props = {
        editor: this.editor,
        node: this.node,
        decorations: this.decorations,
        selected: false,
        extension: this.extension,
        getPos: function getPos() {
          return _this6.getPos();
        },
        updateAttributes: function updateAttributes() {
          var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return _this6.updateAttributes(attributes);
        }
      };
      var onDragStart = this.onDragStart.bind(this);
      this.decorationClasses = Vue.observable({
        value: this.getDecorationClasses()
      });
      var Component = Vue.extend(this.component).extend({
        props: Object.keys(props),
        provide: function provide() {
          return {
            onDragStart: onDragStart,
            decorationClasses: _this6.decorationClasses
          };
        }
      });
      this.renderer = new VueRenderer(Component, {
        parent: this.editor.contentComponent,
        propsData: props
      });
    }
  }, {
    key: "dom",
    get: function get() {
      if (!this.renderer.element.hasAttribute('data-node-view-wrapper')) {
        throw Error('Please use the NodeViewWrapper component for your node view.');
      }

      return this.renderer.element;
    }
  }, {
    key: "contentDOM",
    get: function get() {
      if (this.node.isLeaf) {
        return null;
      }

      var contentElement = this.dom.querySelector('[data-node-view-content]');
      return contentElement || this.dom;
    }
  }, {
    key: "update",
    value: function update(node, decorations) {
      if (typeof this.options.update === 'function') {
        return this.options.update(node, decorations);
      }

      if (node.type !== this.node.type) {
        return false;
      }

      if (node === this.node && this.decorations === decorations) {
        return true;
      }

      this.node = node;
      this.decorations = decorations;
      this.decorationClasses.value = this.getDecorationClasses();
      this.renderer.updateProps({
        node: node,
        decorations: decorations
      });
      return true;
    }
  }, {
    key: "selectNode",
    value: function selectNode() {
      this.renderer.updateProps({
        selected: true
      });
    }
  }, {
    key: "deselectNode",
    value: function deselectNode() {
      this.renderer.updateProps({
        selected: false
      });
    }
  }, {
    key: "getDecorationClasses",
    value: function getDecorationClasses() {
      return this.decorations // @ts-ignore
      .map(function (item) {
        return item.type.attrs["class"];
      }).flat().join(' ');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.renderer.destroy();
    }
  }]);

  return VueNodeView;
}(NodeView);

function VueNodeViewRenderer(component, options) {
  return function (props) {
    // try to get the parent component
    // this is important for vue devtools to show the component hierarchy correctly
    // maybe it’s `undefined` because <editor-content> isn’t rendered yet
    if (!props.editor.contentComponent) {
      return {};
    }

    return new VueNodeView(component, props, options);
  };
}

var NodeViewWrapper = Vue.extend({
  props: {
    as: {
      type: String,
      "default": 'div'
    }
  },
  inject: ['onDragStart', 'decorationClasses'],
  render: function render(createElement) {
    return createElement(this.as, {
      // @ts-ignore
      "class": this.decorationClasses.value,
      style: {
        whiteSpace: 'normal'
      },
      attrs: {
        'data-node-view-wrapper': ''
      },
      on: {
        // @ts-ignore
        dragstart: this.onDragStart
      }
    }, this.$slots["default"]);
  }
});
var NodeViewContent = Vue.extend({
  props: {
    as: {
      type: String,
      "default": 'div'
    }
  },
  render: function render(createElement) {
    return createElement(this.as, {
      style: {
        whiteSpace: 'pre-wrap'
      },
      attrs: {
        'data-node-view-content': ''
      }
    });
  }
});
export { BubbleMenu, Editor, EditorContent, FloatingMenu, NodeViewContent, NodeViewWrapper, VueNodeViewRenderer, VueRenderer, nodeViewProps };